import React from 'react'

const Plus = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.2522 8.00005C15.2522 12.0053 12.0053 15.2522 8.00005 15.2522C3.99481 15.2522 0.747925 12.0053 0.747925 8.00005C0.747925 3.99481 3.99481 0.747925 8.00005 0.747925C12.0053 0.747925 15.2522 3.99481 15.2522 8.00005ZM11.0842 7.36732H8.87458V4.949H7.18053V7.36732H4.95862V8.91406H7.18053V11.4551H8.87458V8.91406H11.0842V7.36732Z'
      fill='#878787'
    />
  </svg>
)

export { Plus }

export default Plus
